// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1hc1i","approved":"Status_approved__2PGgQ","rejected":"Status_rejected__vojsS","expired":"Status_expired__1ufFG","label":"Status_label__3hegG"};